import React from 'react';
import { InputGroup, Select } from '@nearst/ui';

import styles from './RoundingDropdown.module.scss';

const convertCurrency = (value, currency) => value.toLocaleString('en', { style: 'currency', currency });

const makeRoundingString = (value, currency) => `Round up to ${convertCurrency(value, currency)}`;

const RoundingDropdown = ({ id, label, disabled, onUpdate, currency, value }) => {
	const noRounding = null;
	const roundToWhole = 1;
	const roundTo10 = 0.1;
	const roundTo5 = 0.05;

	return (
		<InputGroup label={label}>
			<Select
				onChange={({ target }) => {
					value = +target.value ? +target.value : null;
					onUpdate(target, value);
				}}
				className={styles.roundingDropdown}
				defaultValue={value}
				id={id}
				disabled={disabled}
			>
				<option value={noRounding}>No rounding</option>
				<option value={roundToWhole}>{makeRoundingString(roundToWhole, currency)}</option>
				<option value={roundTo10}>{makeRoundingString(roundTo10, currency)}</option>
				<option value={roundTo5}>{makeRoundingString(roundTo5, currency)}</option>
			</Select>
		</InputGroup>
	);
};

export default RoundingDropdown;
